// Components/BlogsCards/BlogDetailWrapper.js
import React from "react";
import { useParams } from "react-router-dom";
import BlogDetail1 from "./BlogDetail1";
import BlogDetail2 from "./BlogDetail2";
import BlogDetail3 from "./BlogDetail3";
import BlogDetail4 from "./BlogDetail4";
import BlogDetail5 from "./BlogDetail5";
import BlogDetail6 from "./BlogDetail6";
// import BlogDetail3, BlogDetail4, etc. if needed

const BlogDetailWrapper = () => {
  const { id } = useParams(); // gets :id from the URL

  const blogComponents = {
    1: <BlogDetail1 />,
    2: <BlogDetail2 />,
    3: <BlogDetail3 />,
    4: <BlogDetail4 />,
    5: <BlogDetail5 />,
    6: <BlogDetail6 />,
   
  };

  return blogComponents[id] || <div>Blog not found</div>;
};

export default BlogDetailWrapper;
